var _defs, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGb3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GB3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.12 45.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-gb3-1{fill:#e1251b !important;}.cls-gb3-2{fill:#fff !important;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.78,31.67V23.43H17.93V17.21H35.34V38.09H16.66c-.62-.09-1.15-.17-1.59-.22a10.18,10.18,0,0,1-1.49-.29c-.55-.15-1.32-.4-2.29-.76a13.51,13.51,0,0,1-3.7-2.45,12.52,12.52,0,0,1-3.47-5.49,23.45,23.45,0,0,1-1.24-7.75V19a18.25,18.25,0,0,1,.59-4.8A19.32,19.32,0,0,1,5,10.15,14.1,14.1,0,0,1,7.36,6.89a14.9,14.9,0,0,1,4-2.73Q14,2.84,19.45,2.84H35.34V9H19.45a7.76,7.76,0,0,0-5,1.49,8,8,0,0,0-2.55,4,20.53,20.53,0,0,0-.74,5.69v.54q0,5.15,1.74,8t6.6,2.89Z",
    transform: "translate(-2.88 -2.84)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.56,38.09H40.19V2.84H58.28A28.24,28.24,0,0,1,63,3.18a22.94,22.94,0,0,1,4.49,1.38,5.08,5.08,0,0,1,3.19,3.8,20.61,20.61,0,0,1,.63,4.19q0,5-5.19,7.94a11.73,11.73,0,0,1,2.94,2,7.63,7.63,0,0,1,1.81,2.58,7.91,7.91,0,0,1,.59,3.16,17.36,17.36,0,0,1-.49,3.68,5.8,5.8,0,0,1-1.74,3.26,13.15,13.15,0,0,1-2.25,1.57,13,13,0,0,1-2.9.93A20.92,20.92,0,0,1,59.56,38.09ZM58.38,9.17H47.59V17.3H58.38A6.08,6.08,0,0,0,62,16.37a3.57,3.57,0,0,0,1.27-3.09Q63.28,9.17,58.38,9.17ZM47.59,23.53v8.34H58.41a5.86,5.86,0,0,0,3.63-1,3.74,3.74,0,0,0,1.24-3.16q0-4.21-4.87-4.22Z",
    transform: "translate(-2.88 -2.84)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84,13.9h2.29V14a1.26,1.26,0,0,0,.28.9,1,1,0,0,0,.82.31,1.22,1.22,0,0,0,.87-.29,1.14,1.14,0,0,0,.3-.85,1.21,1.21,0,0,0-.32-.92,1.48,1.48,0,0,0-1-.29h-.27V11.45H87a1.48,1.48,0,0,0,1-.27,1,1,0,0,0,.33-.79.85.85,0,0,0-.28-.67,1.14,1.14,0,0,0-1.44,0,1,1,0,0,0-.28.72H84.15a2.46,2.46,0,0,1,.89-2,3.68,3.68,0,0,1,2.41-.7,3.4,3.4,0,0,1,2.17.63,2,2,0,0,1,.8,1.7,1.89,1.89,0,0,1-.37,1.16A2.09,2.09,0,0,1,89,12a2.07,2.07,0,0,1,1.31.73,2.27,2.27,0,0,1,.47,1.49,2.72,2.72,0,0,1-.93,2.14,4.09,4.09,0,0,1-5,0A3,3,0,0,1,84,14Z",
    transform: "translate(-2.88 -2.84)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.36,3.24h4.55V5.41H80V18.63h2V20.8H77.36Z",
    transform: "translate(-2.88 -2.84)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4,3.24V20.8H92.87V18.63h1.94V5.41H92.87V3.24Z",
    transform: "translate(-2.88 -2.84)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.12,
    y: 39.16,
    width: 95,
    height: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-gb3-1",
    x: 54.12,
    y: 39.16,
    width: 30,
    height: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-gb3-2",
    x: 60.12,
    y: 39.16,
    width: 3,
    height: 6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-gb3-2",
    x: 65.12,
    y: 39.16,
    width: 3,
    height: 6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-gb3-2",
    x: 70.12,
    y: 39.16,
    width: 3,
    height: 6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-gb3-2",
    x: 75.12,
    y: 39.16,
    width: 3,
    height: 6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb3);
export default __webpack_public_path__ + "static/media/GB3.0e9383ff8ff2f09ecb5c8bc5e9ac4d70.svg";
export { ForwardRef as ReactComponent };